module.exports.SerTicketShowView = () => import(/* webpackChunkName: "SerTicketShowView" */ 'pages/ser-ticket/show')
module.exports.SerTicketPayView = () => import(/* webpackChunkName: "SerTicketPayView" */ 'pages/ser-ticket/pay')
module.exports.SerTicketUnparkView = () => import(/* webpackChunkName: "SerTicketUnparkView" */ 'pages/ser-ticket/unpark')
module.exports.EmptyView = () => import(/* webpackChunkName: "EmptyView" */ 'views/commons/empty')
